import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useMemo } from 'react';

import { Checkbox } from '../../uikit';
import { CheckboxWithToolTip } from '../WithTooltip';

interface IAgCheckBoxHeaderComponent extends IHeaderParams {
    checkedIds?: number[];
    allIds?: number[];
    message?: string;
    isDisabled?: boolean;
    onCheckChange: (checkedIds: number[]) => void;
}

const style = { display: 'flex', alignItems: 'center' };

export const AgCheckBoxHeaderComponent: React.FC<IAgCheckBoxHeaderComponent> = (props) => {
    const { checkedIds, allIds, message, isDisabled, onCheckChange } = props;

    const checkboxProps = useMemo(
        () => ({
            checked: !!(checkedIds?.length && allIds?.length && checkedIds?.length === allIds?.length),
            intermediate: !!(checkedIds?.length && allIds?.length && checkedIds?.length !== allIds?.length),
            disabled: isDisabled,
        }),
        [allIds?.length, checkedIds?.length, isDisabled],
    );

    const onCheckChangeLocal = useCallback(
        ({ checked }: { checked: boolean }) => {
            onCheckChange?.(checked && allIds ? allIds : []);
        },
        [allIds, onCheckChange],
    );

    return (
        <div style={style}>
            {message ? (
                <CheckboxWithToolTip
                    checkboxProps={checkboxProps}
                    tooltipProps={{
                        mode: 'mouseover',
                        content: message,
                    }}
                    fakeDisabled={isDisabled}
                />
            ) : (
                <Checkbox
                    intermediate={checkboxProps?.intermediate}
                    checked={checkboxProps?.checked}
                    onChange={onCheckChangeLocal}
                    disabled={checkboxProps?.disabled}
                />
            )}
        </div>
    );
};

AgCheckBoxHeaderComponent.displayName = 'AgCheckBoxHeaderComponent';
